import { actions } from './constants'

import { factoryReducer, flattenStringMap } from '../../../../../reducers/utils'

const initialState = {
  reappriseID: undefined,
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.INITIALIZE:
      return {
        reappriseID: payload.reappriseID,
      }

    case actions.REAPPRISE:
      return {
        reappriseID: payload.reappriseID,
      }

    default:
      return state
  }
}

export default factoryReducer(
  // @ts-ignore
  {
    registerType: actions.INITIALIZE,
  },
  flattenStringMap(actions),
  reducer,
  (meta) => meta.ID,
)
